import { measurementConstants } from "./constants";

export function measurementList(state = {}, action) {
  switch (action.type) {
    case measurementConstants.MEASUREMENT_LIST_REQUEST:
      return {
        payload: action.payload
      };
    case measurementConstants.MEASUREMENT_LIST_SUCCESS:
      return {
        payload: action.payload
      };
    case measurementConstants.MEASUREMENT_LIST_FAILURE:
      return {};
    default:
      return state;
  }
}
